import type { KnowledgeBaseLibraryEntry } from "knowledge-base/_api/knowledge-base-api";

/**
 * The external libraries belonging to other organizations the reader works for.
 *
 * "Not own" rather than "External": the reader's own external library is also external, and it is
 * already one of the two tabs above the contents. What this picks out is the shelf of other
 * people's rules, which is the part nothing outside the knowledge base page linked to.
 */
export function clientLibraries(
  libraries: readonly KnowledgeBaseLibraryEntry[] | undefined
): KnowledgeBaseLibraryEntry[] {
  return (libraries ?? []).filter((entry) => !entry.isOwn && entry.library === "External");
}
